import {Input} from 'antd';

import {EEditableInput} from 'components/editable-table/model/types';
import {CustomSelect} from 'components/form/inputs/custom-select';
import {StaticSelect} from 'components/form/inputs/static-select';
import {DateCell} from 'components/table/columns/date-cell/date-cell';
import {FilesModalCell} from 'components/table/columns/file-modal-cell';
import {InputNumberCell} from 'components/table/columns/input-number-cell';
import {TextModalCell} from 'components/table/columns/text-modal-cell';

export const EDITABLE_TABLE_LIST_NAME = 'editableTable';

export const EditableTableInput = {
    [EEditableInput.TEXT]: Input,
    [EEditableInput.SELECT]: StaticSelect,
    [EEditableInput.TEMPLATE_SELECT]: CustomSelect,
    [EEditableInput.DATE]: DateCell,
    [EEditableInput.INPUT_NUMBER]: InputNumberCell,
    [EEditableInput.TEXT_MODAL]: TextModalCell,
    [EEditableInput.FILES_MODAL]: FilesModalCell,
};